import { addErrorToReport } from '@americanexpress/one-app-ducks';
import { getFaasApiUrl } from '../selectors/selectors';
import { MODULENAME, ROOT_READ_USER_SESSIONS } from '../constants/constants';

export const readUserSession = (state, fetchClient = fetch) => {
  const url = `${getFaasApiUrl(state)}/ReadUserSession.v1`;
  return fetchClient(url, { mode: 'cors', credentials: 'include' })
    .then((response) => {
      if (response.ok) {
        return true;
      }
      return false;
    })
    .catch((error) => {
      const errorData = { message: 'An Error occurred while reading user session', moduleName: MODULENAME, customerJourney: ROOT_READ_USER_SESSIONS };
      addErrorToReport(error, errorData);
      throw new Error('An Error occurred while reading user session', error);
    });
};
